export default __webpack_public_path__ + "static/media/phase2.5a56263d.svg";